module.exports = __webpack_public_path__ + "static/media/logologinnovo.9531b597.png";